import axios from "axios";

export default class KrmService {
    getData(endpoint, data) {
        return axios.post(endpoint, data)
            .then(res => res.data);
    }
}
